// displayMode.ts — ¿la página corre en el navegador o como app instalada (PWA / WebAPK)?
//
// Round 2026-10-28. Los reportes del dueño distinguían «en el navegador funciona, en la app
// instalada no», pero el código no tenía forma de saber en cuál de los dos estaba corriendo,
// así que ningún error podía atribuirse a un modo. Esto lo etiqueta (Sentry lo usa como tag
// `display-mode`).
//
// Criterio: `standalone` si la app está instalada y sin barra del navegador — `display-mode:
// standalone` (Chrome/Android/escritorio), `fullscreen`/`minimal-ui` (variantes de la misma
// instalación) o `navigator.standalone` (iOS Safari, que no soporta la media query). Todo lo
// demás es `browser`.
//
// OJO: es SOLO diagnóstico. Ninguna decisión de layout debe colgar de esto (el layout se
// resuelve con el viewport: `dvh` ya recoge la diferencia de la barra del navegador).

export type DisplayMode = "standalone" | "browser";

export function getDisplayMode(): DisplayMode {
  try {
    if (typeof window === "undefined") return "browser";
    const mm = typeof window.matchMedia === "function" ? window.matchMedia.bind(window) : null;
    if (mm) {
      for (const modo of ["standalone", "fullscreen", "minimal-ui"]) {
        if (mm(`(display-mode: ${modo})`).matches) return "standalone";
      }
    }
    if ((window.navigator as Navigator & { standalone?: boolean }).standalone === true) {
      return "standalone";
    }
  } catch {
    // matchMedia puede no existir (entornos viejos / jsdom): se asume navegador.
  }
  return "browser";
}
